import groupBy from "lodash/groupBy";
import keyBy from "lodash/keyBy";
import map from "lodash/map";
import mapValues from "lodash/mapValues";
import uniq from "lodash/uniq";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { MatchedCustomValue, Snakify } from "PFCore/types";

type CustomValueParentChildItem = Snakify<Pick<MatchedCustomValue, "customValue" | "originalCustomValue">>;

export type GetParentChildSkillsMap = {
  customValues: {
    parent: CustomValueParentChildItem[];
    child: CustomValueParentChildItem[];
  } | null;
};

export type ParentChildValues = {
  parentValues: CustomValueParentChildItem["customValue"][];
  childValues: CustomValueParentChildItem["customValue"][];
};

export type ParentChildMap = Record<string, ParentChildValues>;

type GetParentChildSkillsMapReturn = {
  parentChildMap: ParentChildMap;
};

export const getParentChildSkillsMap = ({
  customValues
}: GetParentChildSkillsMap): GetParentChildSkillsMapReturn => {
  if (!customValues) {
    return {
      parentChildMap: {}
    };
  }

  const parentByOriginalId = groupBy(customValues.parent, (value) =>
    getAttribute(getAttribute(value, "originalCustomValue"), "globalId")
  );
  const childByOriginalId = groupBy(customValues.child, (value) =>
    getAttribute(getAttribute(value, "originalCustomValue"), "globalId")
  );

  const allIds = uniq([...Object.keys(parentByOriginalId), ...Object.keys(childByOriginalId)]);

  const parentChildMap: ParentChildMap = mapValues(keyBy(allIds), (_, id) => ({
    parentValues: map(parentByOriginalId[id] || [], (parentItem) => getAttribute(parentItem, "customValue")),
    childValues: map(childByOriginalId[id] || [], (childItem) => getAttribute(childItem, "customValue"))
  }));

  return {
    parentChildMap
  };
};
